import { render, staticRenderFns } from "./DuplicatePostSelection.vue?vue&type=template&id=2e15ea44&scoped=true&"
import script from "./DuplicatePostSelection.vue?vue&type=script&lang=js&"
export * from "./DuplicatePostSelection.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatePostSelection.vue?vue&type=style&index=0&id=2e15ea44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e15ea44",
  null
  
)

export default component.exports